import SEO from "@/components/SEO";
import { COMPANY } from "@/data/services";
import { SITE_URL } from "@/config/site";

export default function MentionsLegales() {
  return (
    <>
      <SEO
        title="Mentions légales — Perspective Assurance"
        description="Mentions légales du site Perspective Assurance, courtier en assurance à Lyon."
        canonical={`${SITE_URL}/mentions-legales`}
      />
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10 lg:px-12">
          <h1 className="font-display text-4xl sm:text-5xl text-forest mb-10">Mentions légales</h1>
          <div className="space-y-8 text-forest/80 leading-relaxed">
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Éditeur du site</h2>
              <p>Perspective Assurance — Cabinet de courtage en assurances</p>
              <p>Adresse : {COMPANY.address}</p>
              <p>Téléphone : <a href={`tel:${COMPANY.phone}`} className="text-terracotta">{COMPANY.phoneDisplay}</a></p>
              <p>Email : <a href={`mailto:${COMPANY.email}`} className="text-terracotta break-all">{COMPANY.email}</a></p>
              <p>Directeur de publication : Julien Maertens</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Activité réglementée</h2>
              <p>Perspective Assurance est immatriculée à l'ORIAS en qualité de courtier en assurances. Sous le contrôle de l'ACPR (Autorité de Contrôle Prudentiel et de Résolution), 4 Place de Budapest, 75009 Paris.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Hébergement</h2>
              <p>Ce site est hébergé sur une infrastructure cloud sécurisée.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Propriété intellectuelle</h2>
              <p>L'ensemble des contenus présents sur ce site (textes, images, graphismes, logo) sont la propriété exclusive de Perspective Assurance, sauf mention contraire. Toute reproduction est interdite sans autorisation préalable.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Données personnelles</h2>
              <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité de vos données. Pour exercer ces droits, contactez-nous à {COMPANY.email}.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Cookies</h2>
              <p>Ce site utilise des cookies à des fins de mesure d'audience. Vous pouvez les désactiver dans les paramètres de votre navigateur.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
